import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getBasedIdentityCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].getBasedIdentityCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getFullIdentityCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].getFullIdentityCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedIdentityCards(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].getExtendedIdentityCards,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function getIdentityPreview(companyId, identityId) {
	return dataTransferWrap(ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].getIdentityCardsPreview, {
		urlParams: {
			companyId,
			identityId,
		},
	})
}
function createIdentityCard(companyId, data) {
	return dataTransferWrap(ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].createIdentityCard, {
		urlParams: {
			companyId,
		},
		...data,
	})
}
function deleteIdentityCard(companyId, identityId) {
	return dataTransferWrap(ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].deleteIdentityCard, {
		urlParams: {
			companyId,
			identityId,
		},
	})
}
function getIdentityCard(companyId, identityId) {
	return dataTransferWrap(ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].getIdentityCard, {
		urlParams: {
			companyId,
			identityId,
		},
	})
}
function patchIdentityCard(companyId, identityId, data) {
	return dataTransferWrap(ModulesMap.IDENTITY_CARDS,dtConfig[ModulesMap.IDENTITY_CARDS].patchIdentityCard, {
		urlParams: {
			companyId,
			identityId,
		},
		...data,
	})
}
export default {
	getBasedIdentityCards,
	getFullIdentityCards,
	getExtendedIdentityCards,
	getIdentityPreview,
	createIdentityCard,
	getIdentityCard,
	patchIdentityCard,
	deleteIdentityCard
}
